export default __webpack_public_path__ + "static/media/tennis.168092ef.png";